module.exports = __webpack_public_path__ + "img/thumb.9f4b18f0.jpeg";